import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ProductDto } from "../../../dtos/ProductDto";
import { CartService } from "../../../services/cart.service";
import { ToastService } from "../../../services/toast.service";

@Component({
  selector: 'app-product-detail',
  standalone: false,
  templateUrl: './app-product-detail.component.html',
  styleUrl: './app-product-detail.component.scss',
  host: {
    class: 'row flex-grow-1'
  }
})
export class ProductDetailComponent implements OnInit {
 @Input() product: ProductDto;

  constructor(
    private activatedRoute: ActivatedRoute,
    private cartService: CartService,
    private toastService: ToastService,
  ) {}

 async ngOnInit() {
   this.activatedRoute.data.subscribe(({ product }) => {
     this.product = product;
   })
 }

 async addToCart() {
    const cartId = localStorage.getItem('cartId');
    this.cartService.addToCart(this.product.id).subscribe(({ id }) => {
      if(!cartId)
        localStorage.setItem('cartId', id!);

      this.showSuccessToast();
    }, ({error}) => {
      console.error(error.message);
      this.showFailureToast(error.message);
    });
 }

  showSuccessToast() {
    this.toastService.show('Successfully added item to cart.', { header: 'Product Added', classname: 'bg-success text-light' });
  }

  // overloaded methods
  showFailureToast(): void;
  showFailureToast(message: string): void;
  
  showFailureToast(message?: string): void {
    if(message)
      this.toastService.show(message, { header: 'Failed to Add Product', classname: 'bg-danger text-light' });      
    else
      this.toastService.show('Please message us for support.', { header: 'Failed to Add Product', classname: 'bg-danger text-light' });
  }
}